import { render } from "./ThankYouGalleries.vue?vue&type=template&id=911b51e8&scoped=true"
const script = {}

import "./ThankYouGalleries.vue?vue&type=style&index=0&id=911b51e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911b51e8"]])

export default __exports__